module.exports = __webpack_public_path__ + "media/plusBtn.4165e521.svg";